import HomeComponent from './Home'


export const Home = HomeComponent


// WEBPACK FOOTER //
// ./src/app/home/components/index.js